import { render, staticRenderFns } from "./ModalCreateQuickProtocol.vue?vue&type=template&id=9f2da0ec&scoped=true"
import script from "./ModalCreateQuickProtocol.vue?vue&type=script&lang=js"
export * from "./ModalCreateQuickProtocol.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateQuickProtocol.vue?vue&type=style&index=0&id=9f2da0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2da0ec",
  null
  
)

export default component.exports